import { Box, Stack, Typography } from '@mui/material';
import React from 'react';
import { MoLink } from '../MoLink';
import { SessionAttendanceInput, SessionAttendanceStatus } from '../SessionAttendanceStatus';

export type SuperviseeAttendee = SessionAttendanceInput & {
  user: { id: number; fullName: string };
};

export type SuperviseeAttendeeListProps = {
  attendees: SuperviseeAttendee[];
  showAttendance: boolean;
  getProfilePath?: (superviseeUserId: number) => string | undefined;
};

export function SuperviseeAttendeeList({
  attendees,
  showAttendance,
  getProfilePath,
}: SuperviseeAttendeeListProps) {
  return (
    <Stack spacing={0.5} fontWeight="bold">
      {attendees.map((attendee) => {
        const to = getProfilePath?.(attendee.user.id);
        return (
          <Box key={attendee.user.id} display="flex" alignItems="center" gap={1}>
            {showAttendance && <SessionAttendanceStatus attendee={attendee} iconOnly />}
            {to ? (
              <MoLink to={to}>{attendee.user.fullName}</MoLink>
            ) : (
              <Typography fontWeight="bold">{attendee.user.fullName}</Typography>
            )}
          </Box>
        );
      })}
    </Stack>
  );
}
